module.exports = __webpack_public_path__ + "static/media/github-icon.71edeaef.svg";